import api from '@/api/axiosApi'
import type {
  BuyStrategyCodeRead,
  ConsolidatedDcRead,
  DefaultStrategyGroup,
  MilestoneRead,
} from './clt.types'

export async function listMilestones(): Promise<MilestoneRead[]> {
  const response = await api.get<MilestoneRead[]>('/milestones')
  return response.data
}

export async function listBuyStrategyCodes(): Promise<BuyStrategyCodeRead[]> {
  const response = await api.get<BuyStrategyCodeRead[]>(
    '/stocking-strategy-codes'
  )
  return response.data
}

export async function listDefaultStrategyGroups(): Promise<
  DefaultStrategyGroup[]
> {
  const response = await api.get<DefaultStrategyGroup[]>(
    '/stocking-strategy-codes/default-groups'
  )
  return response.data
}

export async function listConsolidatedDcs(): Promise<ConsolidatedDcRead[]> {
  const response = await api.get<ConsolidatedDcRead[]>('/consolidated-dcs')
  return response.data
}
